export default __webpack_public_path__ + "static/media/departed-port-for-rail-terminal.90bb4f1a.svg";